module.exports = __webpack_public_path__ + "static/media/320x100_0008_ru.74bd31d8.jpg";